import axios from "axios";

// Recording-S3-migration (issue #18): GET /api/getCallRecordingMedia/:recordingSid can resolve
// two different ways depending on whether the recording has finished its background S3 upload
// (issue #16/#17):
//   - upload_status === "uploaded" -> 200 JSON { url, expiresIn, source: "s3" }, a short-lived
//     presigned S3 URL the browser can hit directly.
//   - otherwise                   -> 200 with the original Twilio-proxied audio bytes, streamed
//     through the backend exactly as before this migration.
// Both cases return HTTP 200, so the response payload itself - not the status code - is what
// tells them apart. This helper always requests the body as a Blob (so binary audio bytes are
// never mangled by a text/JSON transform) and then inspects the actual Content-Type to decide
// whether to parse it as the presigned-URL JSON or turn it into a local blob: object URL, the
// same way the old proxy-only code path did. Every recording player in the app should go through
// this single function so both response shapes are handled consistently.
export const fetchRecordingPlaybackUrl = async (token, recordingSid, practiceId) => {
  const response = await axios.get(`/api/getCallRecordingMedia/${recordingSid}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: { PracticeId: practiceId },
    responseType: "blob",
  });

  const contentType = String(
    response.headers?.["content-type"] || response.data?.type || "",
  ).toLowerCase();

  if (contentType.includes("application/json")) {
    const parsedText = await response.data.text();
    const parsed = JSON.parse(parsedText);

    if (!parsed?.url) {
      throw new Error("Presigned recording response is missing a url");
    }

    return parsed.url;
  }

  return URL.createObjectURL(response.data);
};
